// import Rails from '@rails/ujs';
import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["file", "fileAction", "redirectPath"];

  selectFile(event) {
    event.preventDefault();
    this.fileActionTarget.value = "update";
    if (this.hasRedirectPathTarget) {
      this.redirectPathTarget.value = null;
    }
    this.fileTarget.click();
  }

  destroyFile(event) {
    event.preventDefault();
    this.fileActionTarget.value = "destroy";
    if (this.hasRedirectPathTarget) {
      this.redirectPathTarget.value = null;
    }
    this.submit(event);
  }

  submitWithoutRedirect(event) {
    if (this.hasRedirectPathTarget) {
      this.redirectPathTarget.value = null;
    }
    this.submit(event);
  }

  submitDelayed(event) {
    if (this.timerid) {
      clearTimeout(this.timerid);
    }

    this.timerid = setTimeout(() => {
      this.submit(event);
    }, 500);
  }

  submit(event) {
    event.preventDefault();
    Rails.fire(this.element, "submit");
  }
}
